"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.is = is;
/**
 * Generic type guard. If `isMatched` is `true`, TypeScript assumes `value` is of type `T`.
 * You can use it to narrow types:
 *
 * ```TypeScript
 * interface Foo {
 *   kind: 'Foo';
 * }
 *
 * interface Bar {
 *   kind: 'Bar';
 * }
 *
 * declare const foobar: Foo | Bar;
 *
 * if (is<Foo>(foobar, foobar.kind === 'Foo')) {
 *   // `typeof foobar` is now `Foo`
 * } else {
 *   // `typeof foobar` is now `Bar`
 * }
 * ```
 *
 * @typeParam T Potential type of `value`
 * @param value Value being checked
 * @param isMatched Specifies if `value` is of type `T`
 * @return Value of `isMatched`
 */ function is(value, isMatched) {
    return isMatched;
} //# sourceMappingURL=is.js.map
